import Panel from "@components/panel";

const facetContainers = document.querySelectorAll('[data-panel]');
facetContainers.forEach(container => {
  const configuration = {
    container
  };  
  // Disabling no-new because it is not required to save this object
  // on a variable.
  // eslint-disable-next-line no-new
  new Panel(configuration);
});